import React from "react";
import axios from "axios";
import {getQueryString} from "../../utils";
import { Box, Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import useInput from "../../hooks/useInput";

export default function GenerateFleetModal({
                                             modalOpen,
                                             setModalState,
                                             endpoint,
                                             onChange,
                                             initDate
                                           }) {
  const init = initDate || new Date().toISOString().substr(0, 10)
  const [date, dateInput] = useInput({
    type: "date",
    label: "Delivery Date",
    initialValue: init
  });

  const onGenerate = () => {
    const method = "get";
    const url =
      endpoint + `vehicles/generatefleetnumber${getQueryString({date})}`
    const conf = {
      method,
      url
    };
    axios(conf).then(({data}) => {
      onChange({target: {name: "fleet_number", value: data.fleet_number}});
      onChange({target: {name: "delivery_date", value: date}});
      setModalState({modalOpen: false})
    });
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal
      closeOnBlur
      active={modalOpen}
      onClose={() => setModalState({ modalOpen: false })}
    >
      <Modal.Content>
        <Section style={{ backgroundColor: "grey" }}>
          <Box>
            <Section>
            <Title size="6">Select a Delivery Date to use for Fleet Number generation</Title>
            <p className="is-size-7">Fleet Numbers consist of 2 numbers for the year, followed by a 3 digit id e.g. 21001</p>
            </Section>
            <Section>
            <Columns isMultiline>
              {dateInput}
            </Columns>
            <Columns isMultiline>
            <p >Warning: Generating a new Fleet Number will overwrite any existing Fleet Number as well as any existing Delivery Date.</p>
            </Columns>
            <Columns isMultiline>
              <Column>
                <Button
                  color="success"
                  onClick={onGenerate}
                >
                  Generate
                </Button>
              </Column>
              <Column>
                <Button
                  color="danger"
                  onClick={() => setModalState({modalOpen: false})}
                >
                  Cancel
                </Button>
              </Column>
            </Columns>
            </Section>
          </Box>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
